import { createContext, useContext, useEffect, useRef } from 'react';

import { useRGetProfile, ProfileResponse } from '@repositories/common';
import { useLocation } from 'react-router-dom';

import { ProfileProviderProps } from './types';
import { isPublicUrl } from '@utils/isPublicUrl';
import Cookies from 'js-cookie';
import COOKIES_KEY from 'constants/cookies';
import sentry from '../../services/sentry';

const ProfileContext = createContext<{
  data: ProfileResponse | undefined;
  isLoading: boolean;
  isError: boolean;
}>({ data: undefined, isLoading: false, isError: false });

function ProfileProvider(props: ProfileProviderProps) {
  const { children } = props;
  const { pathname } = useLocation();
  const didMountRef = useRef<boolean | null>(null);

  const isPublic = isPublicUrl(pathname);
  const token = Cookies.get(COOKIES_KEY.TOKEN);
  const enableApi = !isPublic && !!token;

  const { data, refetch, isLoading, isError } = useRGetProfile({
    enabled: enableApi,
  });

  useEffect(() => {
    if (enableApi) {
      refetch();
    }
  }, [enableApi, pathname, refetch]);

  useEffect(() => {
    if (data?.data?.application?.applicationId && !didMountRef.current) {
      didMountRef.current = true;
      sentry.setApplicationId(data.data.application.applicationId);
    }
  }, [data]);

  return (
    <ProfileContext.Provider value={{ data: data?.data, isLoading, isError }}>
      {children}
    </ProfileContext.Provider>
  );
}

function useProfile() {
  return useContext(ProfileContext);
}

export { useProfile, ProfileProvider };
